<template>
  <div>
    <component
      v-for="(element, index) in visibleContent"
      :key="`content_element_${index}`"
      :is="getElementComponent(element)"
      :data="element"
      v-bind="{ ...element.properties }"
    ></component>
  </div>
</template>

<script>
import { ContentEnums } from '@/enum/content.js';
import { mapGetters } from 'vuex';

import textBox from './text-box.vue';
import advertTextBox from './advert-text-box.vue';
import companyBenefits from './company-benefits.vue';
import jobBenefits from './job-benefits.vue';
import socialMediaSharing from './job-social-media-share.vue';
import htmlContent from './html-content.vue';
import contentGrid from './content-grid.vue';
import companyDepartments from './company-departments.vue';
import expanderContent from './expander-content.vue';
import accordionContent from './accordion-content.vue';
import imageContent from './image-content.vue';
import imageGrid from './image-grid.vue';
import videoBox from './video-box.vue';
import swiper from './content-swiper.vue';
import testimonials from './testimonial-boxes.vue';
import testimonialSwiper from './testimonial-swiper.vue';
import imageSwiper from './image-swiper.vue';
import advertVideo from './advert-video.vue';

export default {
  name: 'content-area',
  props: {
    content: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters('companyModule', {
      isInternal: 'userIsInternal'
    }),

    visibleContent() {
      return this.content.filter((x) => {
        if (x.visibility === ContentEnums.visibility.Always) {
          return true;
        }

        if (
          x.visibility === ContentEnums.visibility.InternalOnly &&
          this.isInternal
        ) {
          return true;
        }

        if (
          x.visibility === ContentEnums.visibility.ExternalOnly &&
          !this.isInternal
        ) {
          return true;
        }

        return false;
      });
    }
  },

  methods: {
    getElementComponent(contentElement) {
      switch (contentElement.componentType) {
        case ContentEnums.componentTypes.TextBox:
          return textBox;
        case ContentEnums.componentTypes.AdvertTextBox:
          return advertTextBox;
        case ContentEnums.componentTypes.CompanyBenefits:
          return companyBenefits;
        case ContentEnums.componentTypes.JobBenefits:
          return jobBenefits;
        case ContentEnums.componentTypes.ShareIcons:
          return socialMediaSharing;
        case ContentEnums.componentTypes.HtmlContent:
          return htmlContent;
        case ContentEnums.componentTypes.ContentGrid:
          return contentGrid;
        case ContentEnums.componentTypes.CompanyDepartments:
          return companyDepartments;
        case ContentEnums.componentTypes.Expander:
          return expanderContent;
        case ContentEnums.componentTypes.Accordion:
          return accordionContent;
        case ContentEnums.componentTypes.Image:
          return imageContent;
        case ContentEnums.componentTypes.ImageGrid:
          return imageGrid;
        case ContentEnums.componentTypes.VideoBox:
          return videoBox;
        case ContentEnums.componentTypes.Swiper:
          return swiper;
        case ContentEnums.componentTypes.Testimonials:
          return contentElement.content?.length <= 2
            ? testimonials
            : testimonialSwiper;
        case ContentEnums.componentTypes.ImageSwiper:
          return imageSwiper;
        case ContentEnums.componentTypes.AdvertVideo:
          return advertVideo;
      }

      return '';
    }
  }
};
</script>
